export default __webpack_public_path__ + "3436280.png";